import React from 'react';
import { AlertCircle, RefreshCw, X } from 'lucide-react';

interface ErrorMessageProps {
  title?: string;
  message: string;
  type?: 'error' | 'warning' | 'info';
  onRetry?: () => void;
  onDismiss?: () => void;
  className?: string;
  showIcon?: boolean;
}

export default function ErrorMessage({
  title,
  message,
  type = 'error',
  onRetry,
  onDismiss,
  className = '',
  showIcon = true
}: ErrorMessageProps) {
  const getStyles = () => {
    switch (type) {
      case 'warning':
        return {
          container: 'bg-yellow-50 border-yellow-200 text-yellow-800',
          icon: 'text-yellow-600',
          button: 'bg-yellow-100 hover:bg-yellow-200 text-yellow-800'
        };
      case 'info':
        return {
          container: 'bg-blue-50 border-blue-200 text-blue-800',
          icon: 'text-blue-600',
          button: 'bg-blue-100 hover:bg-blue-200 text-blue-800'
        };
      default:
        return {
          container: 'bg-red-50 border-red-200 text-red-800',
          icon: 'text-red-600',
          button: 'bg-red-100 hover:bg-red-200 text-red-800'
        };
    }
  };

  const styles = getStyles();

  return (
    <div className={`border rounded-lg p-4 ${styles.container} ${className}`}>
      <div className="flex items-start">
        {showIcon && (
          <div className="flex-shrink-0">
            <AlertCircle className={`h-5 w-5 ${styles.icon}`} />
          </div>
        )}
        
        <div className={`${showIcon ? 'ml-3' : ''} flex-1`}>
          {title && (
            <h3 className="text-sm font-medium mb-1">
              {title}
            </h3>
          )}
          <p className="text-sm leading-relaxed">
            {message}
          </p>
          
          {(onRetry || onDismiss) && (
            <div className="mt-3 flex space-x-2">
              {onRetry && (
                <button
                  onClick={onRetry}
                  className={`inline-flex items-center px-3 py-1.5 rounded text-xs font-medium transition-colors ${styles.button}`}
                >
                  <RefreshCw className="h-3 w-3 mr-1" />
                  Tekrar Dene
                </button>
              )}
              {onDismiss && (
                <button
                  onClick={onDismiss}
                  className={`inline-flex items-center px-3 py-1.5 rounded text-xs font-medium transition-colors ${styles.button}`}
                >
                  <X className="h-3 w-3 mr-1" />
                  Kapat
                </button>
              )}
            </div>
          )}
        </div>
        
        {onDismiss && !onRetry && (
          <div className="flex-shrink-0 ml-3">
            <button
              onClick={onDismiss}
              className={`inline-flex rounded-md p-1.5 transition-colors ${styles.button}`}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
